/** Only the headers are read, so this also accepts a getInitialProps request. */
type RequestWithHeaders = { headers: Record<string, string | string[] | undefined> };

/**
 * The visitor's ISO-3166-1 alpha-2 country from the edge `x-wix-country-code` header (the same one
 * the framework's GeoDataAspect2 decodes). Pepyaka's external dispatcher sets it on every proxied
 * request from a MaxMind lookup and clears any client-supplied value first, so post-edge it is
 * authoritative. Blank/absent → "" (the edge has no country for this IP).
 *
 * Lives apart from its consumers so a caller that only needs the country — /api/geo — doesn't pull
 * in the identity/site-properties clients that `eligibility` needs.
 */
export function readCountryCode(req: RequestWithHeaders): string {
  const header = req.headers['x-wix-country-code'];
  const raw = Array.isArray(header) ? header[0] : header;
  return (typeof raw === 'string' ? raw : '').trim().toUpperCase();
}
